import React from 'react';
import { useParams } from 'react-router-dom';
import { strings } from 'strings';

import { GameEventForm } from '../../components/GameEventForm';
import { Splash } from '../../../../../../shared/Components';

import useGameEvent from './hooks/useGameEvent';

interface EditGameParamTypes {
  id: string;
}

const EditGameEventScreen = () => {
  const { id } = useParams<EditGameParamTypes>();
  const { gameEvent, isLoading } = useGameEvent({ gameEventId: id });

  if (isLoading || !gameEvent) {
    return <Splash />;
  }

  return (
    <GameEventForm
      title={strings.gameEvent.edit.title}
      value={{
        ...gameEvent,
        difficulty: {
          value: gameEvent.difficulty,
          label: String(gameEvent.difficulty) || '',
        },
        entryFee: gameEvent.entryFee.coins || 0,
        levels:
          gameEvent.levels
            .sort((level, nextLevel) => level.level - nextLevel.level)
            .map((level) => ({
              ...level,
              reward: level.reward.coins || 0,
              difficulty: {
                value: level.difficulty,
                label: String(level.difficulty) || '',
              },
            })) || [],
      }}
    />
  );
};

export default EditGameEventScreen;
